import {initialState as accountInitialState} from './slices/accountSlice';
import {initialState as screenInitialState} from './slices/screenSlice';

export const initialState = {
  account: accountInitialState,
  screen: screenInitialState,
};
